import React, { useState } from "react";



export default function OrganizerPage() {

  const [form, setForm] = useState({ name: "", email: "", phone: "", organization: "", event_type: "", expected_attendees: "", message: "" });

  const [submitted, setSubmitted] = useState(false);

  const [loading, setLoading] = useState(false);



  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    try {

      await fetch("https://comoticket-production.up.railway.app/api/public/organizer-request", {

        method: "POST",

        headers: { "Content-Type": "application/json" },

        body: JSON.stringify(form),

      });

      setSubmitted(true);

    } catch (err) {

      alert("Erreur lors de l'envoi, veuillez ressayer");

    } finally {

      setLoading(false);

    }

  };



  return (

    <div style={{minHeight:"100vh",background:"#0a0a0a",fontFamily:"'Inter',Arial,sans-serif",color:"white"}}>

      <style>{`

        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .form-input { width: 100%; padding: 14px 16px; background: rgba(255,255,255,0.05); border: 1.5px solid rgba(255,255,255,0.1); border-radius: 12px; color: white; font-size: 14px; font-family: inherit; outline: none; transition: border-color 0.2s; }

        .form-input:focus { border-color: #2563eb; background: rgba(37,99,235,0.05); }

        .form-input::placeholder { color: rgba(255,255,255,0.25); }

        select.form-input option { background: #1a1a2e; color: white; }

      `}</style>



      <nav style={{position:"sticky",top:0,zIndex:100,background:"rgba(10,10,10,0.95)",backdropFilter:"blur(20px)",borderBottom:"1px solid rgba(255,255,255,0.06)",padding:"16px 40px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>

        <a href="/events" style={{display:"flex",alignItems:"center",gap:10,textDecoration:"none"}}>

          <div style={{width:36,height:36,background:"#2563eb",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:800,color:"white"}}>C</div>

          <span style={{fontSize:18,fontWeight:800,letterSpacing:"-0.5px",color:"white"}}>ComoTicket</span>

        </a>

        <a href="/events" style={{color:"rgba(255,255,255,0.5)",fontSize:13,textDecoration:"none"}}>Voir les &eacute;v&eacute;nements</a>

      </nav>



      <div style={{maxWidth:1100,margin:"0 auto",padding:"60px 40px",display:"grid",gridTemplateColumns:"1fr 1fr",gap:80,alignItems:"start"}}>

        <div>

          <div style={{display:"inline-block",background:"rgba(37,99,235,0.15)",color:"#60a5fa",padding:"6px 14px",borderRadius:100,fontSize:12,fontWeight:700,marginBottom:24,border:"1px solid rgba(37,99,235,0.3)"}}>

            Pour les organisateurs

          </div>

          <h1 style={{fontSize:48,fontWeight:900,letterSpacing:"-2px",lineHeight:1.1,marginBottom:20}}>

            Vendez vos billets<br /><span style={{color:"#2563eb"}}>aux Comores</span>

          </h1>

          <p style={{fontSize:16,color:"rgba(255,255,255,0.5)",lineHeight:1.7,marginBottom:40}}>

            ComoTicket vous permet de distribuer vos billets via un r&eacute;seau de commer&ccedil;ants physiques partout aux Comores. Pas besoin de carte bancaire, vos clients paient en cash.

          </p>

          <div style={{display:"flex",flexDirection:"column",gap:20}}>

            {[

              {emoji:"&#127978;",title:"R&eacute;seau de commer&ccedil;ants",desc:"Acc&egrave;s &agrave; notre r&eacute;seau de points de vente physiques &agrave; travers tout l'archipel"},

              {emoji:"&#128202;",title:"Suivi en temps r&eacute;el",desc:"Dashboard complet avec ventes, commissions et statistiques d&eacute;taill&eacute;es"},

              {emoji:"&#127918;",title:"Billets &eacute;lectroniques",desc:"QR codes uniques, envoi par email et WhatsApp, validation &agrave; l'entr&eacute;e"},

              {emoji:"&#128176;",title:"Paiement cash",desc:"Adapt&eacute; au march&eacute; comorien, pas besoin de carte bancaire pour vos clients"},

            ].map((item, i) => (

              <div key={i} style={{display:"flex",gap:14,alignItems:"flex-start"}}>

                <div style={{width:44,height:44,background:"rgba(37,99,235,0.1)",borderRadius:12,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0,border:"1px solid rgba(37,99,235,0.2)"}} dangerouslySetInnerHTML={{__html: item.emoji}} />

                <div>

                  <div style={{fontSize:15,fontWeight:700,marginBottom:4}} dangerouslySetInnerHTML={{__html: item.title}} />

                  <div style={{fontSize:13,color:"rgba(255,255,255,0.4)",lineHeight:1.6}} dangerouslySetInnerHTML={{__html: item.desc}} />

                </div>

              </div>

            ))}

          </div>

        </div>



        <div style={{background:"#111",borderRadius:20,padding:36,border:"1px solid rgba(255,255,255,0.06)"}}>

          {submitted ? (

            <div style={{textAlign:"center",padding:"40px 0"}}>

              <div style={{width:72,height:72,background:"rgba(37,99,235,0.15)",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 20px",fontSize:32,border:"2px solid #2563eb"}}>✓</div>

              <h2 style={{fontSize:24,fontWeight:800,marginBottom:12}}>Demande envoy&eacute;e !</h2>

              <p style={{color:"rgba(255,255,255,0.5)",fontSize:14,lineHeight:1.6}}>Notre &eacute;quipe vous contactera sous 24h pour discuter de votre projet et configurer votre espace organisateur.</p>

              <a href="/events" style={{display:"inline-block",marginTop:24,background:"#2563eb",color:"white",padding:"12px 28px",borderRadius:100,fontWeight:700,fontSize:14,textDecoration:"none"}}>Voir les &eacute;v&eacute;nements</a>

            </div>

          ) : (

            <>

              <h2 style={{fontSize:22,fontWeight:800,marginBottom:6}}>Demander une d&eacute;mo</h2>

              <p style={{color:"rgba(255,255,255,0.4)",fontSize:13,marginBottom:28}}>Notre &eacute;quipe vous recontacte sous 24h</p>

              <form onSubmit={handleSubmit}>

                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>

                  <div>

                    <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Nom complet *</label>

                    <input className="form-input" placeholder="Mohamed Ali" value={form.name} onChange={e => setForm({...form,name:e.target.value})} required />

                  </div>

                  <div>

                    <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Email *</label>

                    <input type="email" className="form-input" placeholder="vous@email.com" value={form.email} onChange={e => setForm({...form,email:e.target.value})} required />

                  </div>

                </div>

                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>

                  <div>

                    <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Telephone</label>

                    <input className="form-input" placeholder="+269 321 0000" value={form.phone} onChange={e => setForm({...form,phone:e.target.value})} />

                  </div>

                  <div>

                    <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Organisation</label>

                    <input className="form-input" placeholder="Nom de votre structure" value={form.organization} onChange={e => setForm({...form,organization:e.target.value})} />

                  </div>

                </div>

                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>

                  <div>

                    <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Type d'&eacute;v&eacute;nement</label>

                    <select className="form-input" value={form.event_type} onChange={e => setForm({...form,event_type:e.target.value})}>

                      <option value="">Choisir...</option>

                      <option value="concert">Concert / Musique</option>

                      <option value="sport">&Eacute;v&eacute;nement sportif</option>

                      <option value="festival">Festival</option>

                      <option value="conference">Conf&eacute;rence</option>

                      <option value="autre">Autre</option>

                    </select>

                  </div>

                  <div>

                    <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Participants attendus</label>

                    <select className="form-input" value={form.expected_attendees} onChange={e => setForm({...form,expected_attendees:e.target.value})}>

                      <option value="">Choisir...</option>

                      <option value="moins100">Moins de 100</option>

                      <option value="100-500">100 - 500</option>

                      <option value="500-1000">500 - 1000</option>

                      <option value="plus1000">Plus de 1000</option>

                    </select>

                  </div>

                </div>

                <div style={{marginBottom:24}}>

                  <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>Votre projet</label>

                  <textarea className="form-input" placeholder="D&eacute;crivez votre &eacute;v&eacute;nement..." rows={4} value={form.message} onChange={e => setForm({...form,message:e.target.value})} style={{resize:"vertical"}} />

                </div>

                <button type="submit" disabled={loading} style={{width:"100%",background:"#2563eb",border:"none",color:"white",padding:"14px",borderRadius:12,fontWeight:700,fontSize:15,cursor:"pointer",opacity:loading?0.7:1}}>

                  {loading ? "Envoi en cours..." : <span dangerouslySetInnerHTML={{__html: "Demander une d&eacute;mo gratuite"}} />}

                </button>

              </form>

            </>

          )}

        </div>

      </div>

    </div>

  );

}